import type { NormalizeOAS, OASOutput } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';
import { InvitationState, Name, UserRole } from '../../types/Users';

type O = NormalizeOAS<typeof openapi>;
type ResponseBody = OASOutput<O, '/api/me-optional', 'get'>;

type Result = {
  id: number;
  email: string;
  name: Name;
  role: UserRole;
  inviteState: InvitationState;
  organization: {
    id: number;
    name: string;
    /**
     * The organization's tenant. The media library API takes it as its `companyId` route segment
     * and validates it against the caller, so the page cannot open the library without it.
     */
    tenantGuid: string;
  };
} | null;

export const getMeOptionalFactory = (apiClient: ApiClient) => {
  const getMeOptional = async () => {
    const response = await apiClient['/api/me-optional'].get();
    if (response.status !== 200) {
      return null;
    }

    const responseBody = await response.json();
    return mapResponseToResult(responseBody);
  };

  const mapResponseToResult = (response: ResponseBody): Result => {
    return {
      id: response.id,
      email: response.email,
      name: {
        firstName: response.name.firstName ?? '',
        lastName: response.name.lastName ?? '',
      },
      role: response.role,
      inviteState: response.inviteState,
      organization: {
        id: response.organization.id,
        name: response.organization.name,
        tenantGuid: response.organization.tenantGuid,
      },
    };
  };

  return getMeOptional;
};
